import React, { useCallback } from 'react';
import {
  createStyles, makeStyles, Theme, Grid,
} from '@material-ui/core';

import { Route, useParams, useRouteMatch } from 'react-router';
import { push } from 'connected-react-router';
import { useDispatch, useSelector } from 'react-redux';
import FilterChip from '../../components/filter-bar/FilterChip';
import { selectIsAdmin } from '../../store/modules/users/selectors';
import { getTopTabs } from '../../configs/topTabs';
import { TopTabResource } from '../../configs/topTabs/types';

const useStyles = makeStyles(({ palette, colors }: Theme) => createStyles({
  root: {
    display: 'flex',
    borderBottom: `1px solid ${colors.outlines}`,
    color: palette.filterChip.color,
    marginBottom: 25,
  },
}));

type Props = {
  tabResource: TopTabResource;
  loading: boolean;
};

const ProfileTopTabs = ({ tabResource, loading }: Props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { path } = useRouteMatch();
  const isAdmin = useSelector(selectIsAdmin);
  const redirectToTab = useCallback((nextPath: string) => { dispatch(push(nextPath)); }, [dispatch]);
  const { id } = useParams<{ id: string }>();
  const tabs = getTopTabs(tabResource, { path, redirect: redirectToTab, isAdmin, id });
  const tabsPath = tabs.map((item) => item.path);

  return (
    <Route path={tabsPath}>
      {tabs.length > 0 && !loading && (
        <Grid className={classes.root} style={{ fontSize: 16 }}>
          {tabs.map((tab) => (
            <FilterChip
              key={tab.label}
              objKey={tab.label}
              onChange={tab.onChange}
              value={tab.label}
              isActive={tab.isActive}
              label={tab.label}
              tabStyles
              disabled={tab.disabled}
            />
          ))}
        </Grid>
      )}
    </Route>
  );
};

export default ProfileTopTabs;
